import React from 'react';
import { validated } from 'react-custom-validation';
import dragula from 'react-dragula';
import update from "immutability-helper";
import Toggle from 'react-toggle';

import { isRequired } from 'utils/validations';

import Card from 'components/Card';
import Form from 'components/Form';
import FormRow from 'components/FormRow';
import FormValidationMessage from 'components/FormValidationMessage';
import Icon from 'components/Icon';
import Input from 'components/Input';
import ModalButton from 'components/ModalButton';
import TextArea from 'components/TextArea';

class ChecklistEditForm extends React.Component {
    static propTypes = {
        closeModal: React.PropTypes.func.isRequired,
        contentPiece: React.PropTypes.object.isRequired,
        handleChange: React.PropTypes.func.isRequired,
        isSaving: React.PropTypes.bool.isRequired,
        onValid: React.PropTypes.func.isRequired,
        onInvalid: React.PropTypes.func.isRequired,
        openAddChecklistItemModal: React.PropTypes.func.isRequired,
        removeChecklistItem: React.PropTypes.func.isRequired,
        setContentSingle: React.PropTypes.func.isRequired
    };

    constructor() {
        super();
        this.cardsDragging = null;
    }

    componentDidMount() {
        setTimeout(() => {
            this.startReordering();
        }, 1);
    }

    componentWillUnmount() {
        this._handleSaveContentList();
    }

    startReordering() {
        if(this.cardsDragging == null) {
            let cardsList = document.querySelector('.checklist-edit__form .cards');
            if(cardsList != null) {
                this.cardsDragging = dragula([cardsList], {
                    moves: (el, container, handle) => {
                        return true;
                    }
                });

                this.cardsDragging.on('drop', (el, target, source, sibling) => {

                });
            }
        }
    }

    _handleSaveContentList() {
        let items = this.props.contentPiece.items;
        let cards = Array.prototype.slice.call(document.querySelectorAll('.checklist-edit__form .card'));
        let newItems = [];
        cards.forEach((card, index) => {
            newItems.push(items[parseInt(card.getAttribute('data-index'), 10)]);
        });
        let newContentPieceObj = update(this.props.contentPiece, {
            items: {$set: newItems}
        });
        this.props.setContentSingle(newContentPieceObj);
    }

    render() {
        let { closeModal, contentPiece, handleChange, isSaving, onValid, onInvalid, $field, $validation } = this.props;

        return (
            <Form className="checklist-edit__form modal-form">
                <FormRow>
                    <Input type="text"
                           name="name"
                           placeholder="Name"
                           value={contentPiece.name || ''}
                           {...$field('name', (event) => handleChange(event))} />
                    {$validation.name.show && <FormValidationMessage>{$validation.name.error.reason}</FormValidationMessage>}
                </FormRow>
                <FormRow className="form-row">
                    <TextArea name="description"
                              placeholder="Description"
                              onChange={handleChange.bind(this)}
                              value={contentPiece.description || ''} />
                </FormRow>

                <div className="checklist-edit__add-item"
                     onClick={this.props.openAddChecklistItemModal.bind(this, null)}
                     role="button">
                    <Icon icon="plus" /> Add Checklist Item
                </div>

                <FormRow>
                    <div className="cards">
                        {contentPiece.items.map((item, index) => (
                            <Card
                                className="card--narrow"
                                dataIndex={index}
                                item={item}
                                key={index}
                                onClick={this.props.openAddChecklistItemModal.bind(this, index)}
                                removeItem={this.props.removeChecklistItem.bind(this, index)}
                                type="checklist-item"
                            />
                        ))}
                    </div>
                </FormRow>

                <FormRow className="toggle--wrapper checklist-edit__toggle--wrapper">
                    <Toggle defaultChecked={contentPiece.isInLibrary}
                            icons={false}
                            id="toggleSearchable"
                            name="isInLibrary"
                            onChange={handleChange.bind(this)} />
                    <label htmlFor="toggleSearchable">Searchable Library Content</label>
                </FormRow>

                <div className="modal__buttons">
                    <ModalButton disabled={isSaving === true || contentPiece.items.length === 0}
                                 icon="check"
                                 onClick={(event) => {
                                     event.preventDefault();
                                     this.props.$submit(onValid, onInvalid)}}
                                 text="Done" />
                    <ModalButton className="modal-button--cancel"
                                 disabled={isSaving === true}
                                 icon="cancel"
                                 onClick={closeModal.bind(this)}
                                 text="Cancel" />
                </div>
            </Form>
        );
    }
}

function checklistEditFormValidationConfig(props) {
    const { name } = props.contentPiece;
    return {
        fields: ['name'],
        validations: {
            name: [
                [isRequired, name]
            ]
        }
    }
}

export default ChecklistEditForm = validated(checklistEditFormValidationConfig)(ChecklistEditForm);



// WEBPACK FOOTER //
// ./src/containers/ContentPage/modals/ChecklistEditModal/ChecklistEditForm.js